import RequestAbstract from "../abstract";

export default class PublicBanks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-banks";
    }

}
